import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import {
  uploadExpenseRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  deleteExpenseRedux,
  updateExpenseRedux,
  updateCashInRedux,
  deleteCashInRedux,
  getSingleCashSummaryRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Clock from "./clock";
import { CircleLoader } from "react-spinners";
import { approveExpensesBatch, approveCashInsBatch } from "../../../firebase/firebase.utils";
import { notifyError } from "../../../utils/notify";
import "./approve-expense.css";
export class DailyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      expenseObj: null,
      loader: false,
      filterCategoryCashIn: "",
      filterCategoryCashOut: "",
    };
  }

  componentDidMount = async () => {
    const { expenses, allOffices, allCnfs, allEmployees } = this.props;
    let [type, day, month, year] = this.props.match.params.date.split("-");

    day = parseInt(day);
    month = parseInt(month) - 1;
    year = parseInt(year);
    let date = new Date(year, month, day);

    if (type === "expense") {
      this.props.getAllPendingExpenseByDayRedux(
        date.toLocaleDateString("en-GB")
      );
    } else {
      this.props.getAllPendingCashInByDayRedux(
        date.toLocaleDateString("en-GB")
      );
    }
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { expenseObj } = this.state;
    const {
      expenses,
      allOffices,
      allCnfs,
      allEmployees,
      cashIns,
      currentAdmin,
    } = this.props;
    let [type, day, month, year] = this.props.match.params.date.split("-");
    day = parseInt(day);
    month = parseInt(month) - 1;
    year = parseInt(year);
    let date = new Date(year, month, day);
    console.log(date.toDateString());

    console.log(this.props);
    let total = 0;
    let totalCashIns = 0;
    let renderableExpense = expenses;
    if (this.state.filterCategoryCashOut) {
      renderableExpense = expenses.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashOut.toLowerCase()
      );
    }
    renderableExpense.map((expense) => (total += parseInt(expense.amount)));

    let renderableCashIn = cashIns;
    if (this.state.filterCategoryCashIn) {
      renderableCashIn = cashIns.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashIn.toLowerCase()
      );
    }
    renderableCashIn.map(
      (expense) => (totalCashIns += parseInt(expense.amount))
    );
    return (
      <Fragment>
        <Breadcrumb
          title={type === "expense" ? "Cash Out" : "Cash In"}
          parent="Daily Expense"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid ae-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ae-card">
                <div
                  className="card-header ae-card-header"
                  style={{ flexWrap: "wrap", gap: 10 }}
                >
                  <h5 className="ae-card-title">
                    <i className="icofont-money ae-card-icon"></i>
                    {date.toDateString()}
                  </h5>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 10 }}>
                    {type === "expense" ? (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashOut"
                        className="custom-select ae-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashOut}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All</option>
                        <option value="DAILY COST">DAILY COST</option>
                        <option value="OFFICE">OFFICE</option>
                        <option value="SALARY">SALARY</option>
                        <option value="LOAN">LOAN</option>
                        <option value="SHIPPING">SHIPPING</option>
                        <option value="Boosting">BOOSTING/PROMOTION</option>
                        <option value="REFUND">REFUND</option>
                        <option value="TRANSPORT">TRANSPORT</option>
                        <option value="BUY PRODUCTS">BUY PRODUCTS</option>
                      </select>
                    ) : (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashIn"
                        className="custom-select ae-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashIn}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All </option>
                        <option value="LOAN">LOAN</option>
                        <option value="OTHERS">OTHERS</option>
                        <option value="ORDERS">ORDERS</option>
                      </select>
                    )}
                    <button
                      className="btn ae-approve-btn"
                      data-toggle="modal"
                      data-target="#approveExpenseModal"
                    >
                      <i className="icofont-tick-mark" /> Approve
                    </button>
                  </div>
                </div>
                <div className="card-body ae-table-wrap">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <table className="table ae-table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Cateogry</th>
                          <th scope="col">Sub Category</th>
                          <th scope="col">Note</th>
                          <th scope="col">Amount</th>
                          <th scope="col" className="ae-col-action">Action</th>
                        </tr>
                      </thead>
                      {type === "expense" ? (
                        <tbody>
                          {renderableExpense.map((expense, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>
                                <span className="ae-badge">{expense.category}</span>
                                <br />
                                {expense.imageUrl &&
                                  expense.imageUrl !==
                                    "/static/media/plus image.3dff302b.jpeg" && (
                                    <a href={expense.imageUrl} target="_blank">
                                      <img src={expense.imageUrl} className="ae-thumb" />
                                    </a>
                                  )}
                              </td>
                              <td>{String(expense.subCategory || "").replace(/^undefined-/, "")}</td>
                              <td>{expense.note}</td>
                              <td>{expense.amount}Tk</td>
                              <td className="ae-col-action">
                                {(currentAdmin &&
                                  currentAdmin.adminId ===
                                    "KEd9E4BHofTnhbZbJlViinz3g1G3") ||
                                !expense.unEditable ? (
                                  <>
                                    <button
                                      type="button"
                                      className="ae-icon-btn ae-icon-btn--edit"
                                      data-toggle="modal"
                                      data-target="#personalInfoModal"
                                      onClick={() => {
                                        this.setState({ expenseObj: expense });
                                      }}
                                    >
                                      <i className="icofont-edit" />
                                    </button>
                                    <button
                                      type="button"
                                      className="ae-icon-btn ae-icon-btn--delete"
                                      data-toggle="modal"
                                      data-target="#deleteExpenseModal"
                                      onClick={() => {
                                        this.setState({ expenseObj: expense });
                                      }}
                                    >
                                      <i className="icofont-trash" />
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                          <tr className="ae-total-row">
                            <td colSpan={3}></td>
                            <td>Total</td>
                            <td colSpan={2}>{total}Tk</td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {renderableCashIn.map((expense, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td><span className="ae-badge ae-badge--cashin">{expense.category}</span></td>
                              <td>{String(expense.subCategory || "").replace(/^undefined-/, "")}</td>
                              <td>{expense.note}</td>
                              <td>{expense.amount}Tk</td>
                              <td className="ae-col-action">
                                {(currentAdmin &&
                                  currentAdmin.adminId ===
                                    "KEd9E4BHofTnhbZbJlViinz3g1G3") ||
                                !expense.unEditable ? (
                                  <>
                                    <button
                                      type="button"
                                      className="ae-icon-btn ae-icon-btn--edit"
                                      data-toggle="modal"
                                      data-target="#personalInfoModal"
                                      onClick={() => {
                                        this.setState({ expenseObj: expense });
                                      }}
                                    >
                                      <i className="icofont-edit" />
                                    </button>
                                    <button
                                      type="button"
                                      className="ae-icon-btn ae-icon-btn--delete"
                                      data-toggle="modal"
                                      data-target="#deleteExpenseModal"
                                      onClick={() => {
                                        this.setState({ expenseObj: expense });
                                      }}
                                    >
                                      <i className="icofont-trash" />
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                          <tr className="ae-total-row">
                            <td colSpan={3}></td>
                            <td>Total</td>
                            <td colSpan={2}>{totalCashIns}Tk</td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade ae-page ae-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header ae-modal-header">
                <div className="ae-modal-stamp ae-stamp-font">EDIT ENTRY</div>
                <div className="ae-modal-icon-chip">
                  <i className="icofont-edit" />
                </div>
                <div className="modal-title ae-modal-title" id="exampleModalLabel">
                  Update Expense
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body ae-modal-body">
                <div className="form-group">
                  <label>CATEGORY</label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={expenseObj ? expenseObj.category : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>SUB CATEGORY</label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={
                      expenseObj
                        ? String(expenseObj.subCategory || "").replace(/^undefined-/, "")
                        : ""
                    }
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label>NOTE</label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      this.setState({
                        expenseObj: { ...this.state.expenseObj, note: value },
                      });
                    }}
                    value={expenseObj ? expenseObj.note : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                  />
                </div>
                <div className="form-group">
                  <label>AMOUNT</label>
                  <input
                    type="text"
                    className="form-control"
                    name="amount"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      this.setState({
                        expenseObj: {
                          ...this.state.expenseObj,
                          amount: value,
                        },
                      });
                    }}
                    value={expenseObj ? expenseObj.amount : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Amount"
                  />
                </div>
              </div>
              <div className="modal-footer ae-modal-footer">
                <button
                  type="button"
                  className="ae-btn ae-btn--ghost"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="ae-btn ae-btn--primary"
                  data-dismiss="modal"
                  onClick={() => {
                    if (type === "expense") {
                      this.props.updateExpenseRedux(expenseObj);
                    } else {
                      this.props.updateCashInRedux(expenseObj);
                    }
                  }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade ae-page ae-modal"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header ae-modal-header">
                <div className="ae-modal-stamp ae-modal-stamp--danger ae-stamp-font">
                  DELETE ENTRY
                </div>
                <div className="ae-modal-icon-chip ae-modal-icon-chip--danger">
                  <i className="icofont-trash" />
                </div>
                <div className="modal-title ae-modal-title" id="exampleModalLabel">
                  Delete Expense
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body ae-modal-body">
                <div style={{ marginBottom: 14 }}>
                  Are you sure you want to delete this Expense?
                </div>
                <table className="table ae-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {expenseObj && expenseObj.category} <br />
                        {expenseObj &&
                          expenseObj.imageUrl &&
                          expenseObj.imageUrl !==
                            "/static/media/plus image.3dff302b.jpeg" && (
                            <a href={expenseObj.imageUrl} target="_blank">
                              <img src={expenseObj.imageUrl} className="ae-thumb" />
                            </a>
                          )}
                      </td>
                      <td>
                        {expenseObj &&
                          String(expenseObj.subCategory || "").replace(/^undefined-/, "")}
                      </td>
                      <td>{expenseObj && expenseObj.note}</td>
                      <td>{expenseObj && expenseObj.amount}Tk</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer ae-modal-footer">
                <button
                  type="button"
                  className="ae-btn ae-btn--ghost"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="ae-btn ae-btn--danger"
                  data-dismiss="modal"
                  onClick={() => {
                    if (type === "expense") {
                      this.props.deleteExpenseRedux(expenseObj.id);
                    } else {
                      this.props.deleteCashInRedux(expenseObj.id);
                    }
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade ae-page ae-modal"
          id="approveExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header ae-modal-header">
                <div className="ae-modal-stamp ae-modal-stamp--success ae-stamp-font">
                  APPROVE
                </div>
                <div className="ae-modal-icon-chip ae-modal-icon-chip--success">
                  <i className="icofont-tick-mark" />
                </div>
                <div className="modal-title ae-modal-title" id="exampleModalLabel">
                  Approve {type === "expense" ? "Cash Out" : "Cash In"}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body ae-modal-body">
                <div>
                  Are you sure you want to approve{" "}
                  {type === "expense" ? "Cash Out" : "Cash In"} of{" "}
                  <span style={{ color: "var(--ae-danger)", fontWeight: "bold" }}>
                    {date.toDateString()}
                  </span>
                  ?
                </div>
              </div>
              <div className="modal-footer ae-modal-footer">
                <button
                  type="button"
                  className="ae-btn ae-btn--ghost"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="ae-btn ae-btn--success"
                  disabled={this.state.loader}
                  // data-dismiss="modal"
                  onClick={async () => {
                    this.setState({ loader: true });

                    const result =
                      type === "expense"
                        ? await approveExpensesBatch(renderableExpense, {
                            month: renderableExpense[0].month,
                            date: renderableExpense[0].date,
                            total,
                          })
                        : await approveCashInsBatch(renderableCashIn, {
                            month: renderableCashIn[0].month,
                            date: renderableCashIn[0].date,
                            total: totalCashIns,
                          });

                    if (!result.success) {
                      notifyError(
                        result.message || "Approval failed — nothing was changed."
                      );
                      this.setState({ loader: false });
                      return;
                    }

                    this.setState({ loader: false });
                    document.getElementById("dismiss-modal").click();
                    this.props.history.push("/expense/approve-expense");
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
            <button
              data-dismiss="modal"
              id="dismiss-modal"
              style={{ display: "none" }}
            ></button>
          </div>
        </div>
        {this.state.loader && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(255, 255, 255, 0.25)",
              zIndex: 2000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircleLoader loading={true} color="#fb9404" size={60} />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
    expenses: state.expenses.expenses,
    cashIns: state.cashIns.cashIns,
  };
};

export default connect(mapStateToProps, {
  uploadExpenseRedux,
  deleteExpenseRedux,
  deleteCashInRedux,
  updateCashInRedux,
  updateExpenseRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  getSingleCashSummaryRedux,
})(DailyExpense);
